import { InvoiceCategoryFilter, RateType } from '@treadinc/horizon-api-spec';

import {
  SettlementSearchParamName,
  SettlementSearchParams,
} from '~store/SettlementsStore';

import { GridQSParam } from './GridQSParam';
import { QSParams } from './QSParams';
import { TabQSParam } from './TabQSParam';

export const parseQueryStringParams = (searchParams: URLSearchParams) => {
  const category = searchParams.get('category') as InvoiceCategoryFilter | null;
  const tab = searchParams.get('tab') as TabQSParam | null;
  const grid = searchParams.get('grid') as GridQSParam | null;
  const start_date = searchParams.get('start_date') as string | null;
  const end_date = searchParams.get('end_date') as string | null;
  const project_ids = searchParams.get('project_ids') as string | null;
  const customer_account_ids = searchParams.get('customer_account_ids') as string | null;
  const vendor_account_ids = searchParams.get('vendor_account_ids') as string | null;
  const truck_ids = searchParams.get('truck_ids') as string | null;
  const driver_ids = searchParams.get('driver_ids') as string | null;
  const dropoff_site_ids = searchParams.get('dropoff_site_ids') as string | null;
  const pickup_site_ids = searchParams.get('pickup_site_ids') as string | null;
  const rate_types = searchParams.get('rate_types') as string | null;
  const search = searchParams.get('search') as string | null;

  const params: MaybeNullQSParams = {
    category,
    tab,
    grid,
    start_date,
    end_date,
    project_ids,
    customer_account_ids,
    vendor_account_ids,
    truck_ids,
    driver_ids,
    dropoff_site_ids,
    pickup_site_ids,
    rate_types,
    search,
  };

  return params;
};

type MaybeNullQSParams = {
  [K in keyof QSParams]: QSParams[K] | null;
};

export const deriveSettlementsFiltersParamsFromQueryString = (params: QSParams) => {
  const {
    start_date,
    end_date,
    project_ids,
    customer_account_ids,
    vendor_account_ids,
    truck_ids,
    driver_ids,
    dropoff_site_ids,
    pickup_site_ids,
    rate_types,
    search,
  } = params;

  // Always set date params from URL to ensure they get cleared when "All Dates" is selected
  const settlementSearchParams: SettlementSearchParams = {
    [SettlementSearchParamName.START_DATE]: start_date || undefined,
    [SettlementSearchParamName.END_DATE]: end_date || undefined,
  };

  if (project_ids) {
    settlementSearchParams[SettlementSearchParamName.PROJECTS] = project_ids.split('|');
  }

  if (customer_account_ids) {
    settlementSearchParams[SettlementSearchParamName.CUSTOMERS] =
      customer_account_ids.split('|');
  }

  if (vendor_account_ids) {
    settlementSearchParams[SettlementSearchParamName.VENDORS] =
      vendor_account_ids.split('|');
  }

  if (truck_ids) {
    settlementSearchParams[SettlementSearchParamName.TRUCKS] = truck_ids.split('|');
  }

  if (driver_ids) {
    settlementSearchParams[SettlementSearchParamName.DRIVERS] = driver_ids.split('|');
  }

  if (dropoff_site_ids) {
    settlementSearchParams[SettlementSearchParamName.DROPOFF_SITE] =
      dropoff_site_ids.split('|');
  }

  if (pickup_site_ids) {
    settlementSearchParams[SettlementSearchParamName.PICKUP_SITE] =
      pickup_site_ids.split('|');
  }

  if (rate_types) {
    settlementSearchParams[SettlementSearchParamName.RATE_TYPES] = rate_types.split(
      '|',
    ) as RateType[];
  }

  // Always set SEARCH_QUERY from URL to ensure it gets cleared when navigating
  // between pages (e.g., payables to receivables) that don't have a search param
  settlementSearchParams[SettlementSearchParamName.SEARCH_QUERY] = search || undefined;

  return settlementSearchParams;
};
